import { formatApiResponseTimeWithSeconds } from 'components/ApplicationPerformanceOverview/helper';
import {
  createKpiTileItem,
  checkForNA,
  appendPercentage,
  formatValueWithMiddlewares,
} from '../../../v2/utils/helper';

export default {
  type: 'KpiTile',
  handler: (data) => {
    const { avgApiAppResponseTime, avgApiAppResponseTimeDelta } = data;
    const formattedResponseTime = formatApiResponseTimeWithSeconds(
      avgApiAppResponseTime
    );
    return createKpiTileItem(
      'Average API Response Time',
      formattedResponseTime,
      avgApiAppResponseTimeDelta
        ? {
            isPositiveValue: avgApiAppResponseTimeDelta <= 0,
            text: formatValueWithMiddlewares(
              Math.abs(avgApiAppResponseTimeDelta),
              [checkForNA, appendPercentage]
            ).toString(),
            sideLabel: '',
            showArrow: avgApiAppResponseTimeDelta !== 0,
            arrowReversed: true,
          }
        : []
    );
  },
};
